import Short from 'short-uuid';

export default {
  state: {
    data: {},
    order: [],
    selection: null,
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'USER',
      path: 'user',
      get: { active: true, msg: '' },
      update: { active: true, msg: 'Nutzer aktualisiert.' },
      create: { active: true, msg: 'Nutzer erstellt.', rtr: 'OrgProfile' },
      delete: { active: true, msg: 'Nutzer gelöscht.', rtr: 'OrgProfile' },
      admin: {
        create: { active: true, msg: 'Nutzer erstellt.', rtr: 'AllUsers' },
        delete: { active: true, msg: 'Nutzer gelöscht.', rtr: 'AllUsers' },
      },
    },
  },
  getters: {
    dataById: (state) => (id) => state.data[id] ?? {},
    me: (state) => {
      if (state.selection !== null) {
        return state.data[state.selection];
      }
      return {};
    },
    isPermited: (state, getters) => (type) => {
      // type is the user's type (array/string)
      if (Array.isArray(type)) {
        // ex: ['org_admin', 'org']
        return (type.includes(getters.me.type));
      }
      // ex: 'admin'
      return type === getters.me.type;
    },
  },
  mutations: {
    SET_SELECTION(state, payload) {
      state.selection = payload;
    },
  },
  actions: {
    SOCKET_USERS({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_USERS`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      // commit('SET_LOADING', false);
    },
    SOCKET_USER({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_USER`, payload);
      dispatch('HANDLE_PAYLOAD', payload[1]);

      // commit('SET_LOADING', false);
    },
    SOCKET_USER_ACTIVATION_LINK({ getters, dispatch }, payload) {
      if (process.env.NODE_ENV !== 'production') console.log(`[${getters.config.path}] SOCKET_USER_ACTIVATION_LINK`, payload);
      dispatch('INITIATE_CALLBACK', payload);

      // commit('SET_LOADING', false);
    },
    GET_ACTIVATION_LINK({ commit, getters }, { payload, callback }) {
      commit('CLEAR_ERROR');

      const rid = Short.uuid();
      commit('ADD_QUEUE', { rid, payload: { ...getters.config.get, msg: '', callback } });
      // eslint-disable-next-line no-underscore-dangle
      this._vm.$socket.client.emit(`${getters.config.default}_GET_ACTIVATION_LINK`, rid, { ...payload });
      commit('SET_LOADING', true);
    },
  },
};
